import React, { useEffect, Dispatch, SetStateAction } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import LoadingContent from "../../LoadingContent";
import { countryCodeToFlag } from "../../../utils/Admin";

interface FacebookProps {
  data: any;
  facebookEmbed: string;
  setFacebookEmbed: Dispatch<SetStateAction<string>>;
  onIndividualSubmit: () => void; // Nueva prop recibida del padre
  uploading: boolean; // Nueva prop recibida del padre
}

const UploadRaceFacebook = ({
  data,
  facebookEmbed,
  setFacebookEmbed,
  onIndividualSubmit,
  uploading,
}: FacebookProps) => {
  const MAX_CHARS = 63206;
  const charCount = facebookEmbed.length;
  const isOverLimit = charCount > MAX_CHARS;

  const getRaceName = (length: number, type_race: number) => {
    if (length === 2 && type_race === 1) return "Main Race";
    else if (length === 2 && type_race === 2) return "Sprint Race";
  };

  useEffect(() => {
    if (!data || !data.winners) return;
    setFacebookEmbed(
      data.winners.length === 1
        ? [
            `${countryCodeToFlag(data.grand_prix.grand_prix.flag.code)} ${data.grand_prix.name.toUpperCase()} is over.`,
            "",
            `${data.winners[0].flag_code ? countryCodeToFlag(data.winners[0].flag_code) : "🏁"} ${data.winners[0].username} takes the victory 🏆`,
            `${data.race_results[1].flag_code ? countryCodeToFlag(data.race_results[1].flag_code) : "🏁"} ${data.race_results[1].username} (2º) 🥈`,
            `${data.race_results[2].flag_code ? countryCodeToFlag(data.race_results[2].flag_code) : "🏁"} ${data.race_results[2].username} (3º) 🥉`,
            "",
            `🔗 Race results: ${data.results_link}`,
            `📓 Standings: https://ligavirtualf1.es/en/Season/${data.grand_prix.grand_prix.championship.name.replace(/\s+/g, "")}`,
          ].join("\n")
        : data.winners[0].class_name == null
          ? [
              `${countryCodeToFlag(data.grand_prix.grand_prix.flag.code)} ${data.grand_prix.name.toUpperCase()} is over.`,
              "",
              ...data.winners.map((winner: any) => {
                const flag = winner.flag_code
                  ? countryCodeToFlag(winner.flag_code)
                  : "🏁";
                return `${flag} ${winner.username} in ${getRaceName(data.winners.length, winner.type_race)} 🏆`;
              }),
              "",
              "",
              `🔗 Race results: ${data.results_link}`,
              `📓 Standings: https://ligavirtualf1.es/en/Season/${data.grand_prix.grand_prix.championship.name.replace(/\s+/g, "")}`,
            ].join("\n")
          : [
              `${countryCodeToFlag(data.grand_prix.grand_prix.flag.code)} ${data.grand_prix.name.toUpperCase()} is over.`,
              "",
              ...data.winners.map((winner: any, index: number) => {
                const flag = winner.flag_code
                  ? countryCodeToFlag(winner.flag_code)
                  : "🏁";
                return `🏆 ${winner.class_name} Winner: ${flag} ${winner.username}`;
              }),
              "",
              `🔗 Race results: ${data.results_link}`,
              `📓 Standings: https://ligavirtualf1.es/en/Season/${data.grand_prix.grand_prix.championship.name.replace(/\s+/g, "")}`,
            ].join("\n"),
    );
  }, [data, setFacebookEmbed]);

  if (data == null) return <LoadingContent />;

  return (
    // Cambiado de <Form> a <div className="facebook-form">
    <div className="facebook-form mb-4 p-3 border rounded shadow-sm">
      <Row className="mb-3">
        <Form.Group className="form-group col-md-12">
          <h4>
            <FontAwesomeIcon icon={faFacebook} className="me-2" />
            Facebook [Including GP Image]
          </h4>
        </Form.Group>

        <Form.Group className="form-group" as={Col} md="12">
          <div
            style={{
              marginTop: "6px",
              fontSize: "13px",
              textAlign: "right",
              color: isOverLimit ? "red" : "#dfdfdf",
            }}
          >
            {charCount} / {MAX_CHARS}
          </div>
          <Form.Label>Post (*)</Form.Label>
          <Form.Control
            required
            as="textarea"
            name="facebook_embed"
            rows={5}
            value={facebookEmbed}
            onChange={(e) => setFacebookEmbed(e.target.value)}
            isInvalid={isOverLimit}
          />
        </Form.Group>
      </Row>

      {/* Botón para enviar solo Facebook */}
      <div className="text-center">
        {uploading ? (
          <FontAwesomeIcon icon={faSpinner} className="spinner-button" spin />
        ) : (
          <Button
            type="button" // ESENCIAL: type="button" evita enviar todo el formulario general del padre
            variant="secondary"
            onClick={onIndividualSubmit}
            disabled={isOverLimit}
          >
            Send Facebook Post Only
          </Button>
        )}
      </div>
    </div>
  );
};

export default UploadRaceFacebook;
